module.exports = __webpack_public_path__ + "img/20190706154601603.58a42242.png";